module.exports = __webpack_public_path__ + "static/media/Orange Diver.c9244ccf.jpg";